import mappers from '../../server/api/mappers/vehicles';
/**
 * Land Rover
 *
 * ```
 *     State:   Under offer
 *    Images:   Yes
 *      Bids:   1
 * User bids:   0
 *    Mapper:   Yes
 * ```
 */
export default (settings = { preview: false }) => {
	const mapper = settings.preview ? mappers.vehicleDetailsSneakPeek : mappers.vehicleDetails;

	return mapper({
		additionalDetails: null,
		additionalSpec: null,
		allBids: [
			{
				closingTime: '2020-06-04T16:20:00.038Z',
				createdAt: '2020-06-05T09:06:45.672Z',
				dealer: {
					id: 1304,
					name: 'Some One',
				},
				dealerContact: {
					dealer: {
						id: 1304,
						name: 'Some One',
					},
					id: 293,
					name: 'Some One',
				},
				fee: 200,
				id: 7921,
				isFullMoney: false,
				state: 'Expired',
				value: 100,
			},
		],
		availableFrom: null,
		availableUntil: null,
		bids: {
			activeBidCount: 0,
			usersBids: [],
		},
		closingBidId: null,
		collectionNotes: null,
		createdAt: '2019-02-21T15:19:06.847Z',
		dentsDesc: null,
		displayPrice: 2245,
		distance: null,
		docsNotes: null,
		electricsProblemsDesc: 'USB not working',
		equipment: 'sat_nav,panoramic_roof,heated_seats,parking_cam,sound_system',
		exclusiveToDealer: 'None',
		exteriorGrade: 'gold',
		financeCleaner: 1,
		financeFigure: null,
		hasBeenSmokedIn: null,
		hasDents: false,
		hasElectricsProblems: true,
		hasLockingWheelNut: true,
		hasMissingParts: false,
		hasPaintProblems: false,
		hasPrivatePlate: null,
		hasScratches: false,
		hasScuffedAlloy: false,
		hasServiceRecords: true,
		hasToolsInBoot: true,
		hasV5LogBook: true,
		hasWarningLights: false,
		hasWindscreenProblems: null,
		id: 46947,
		independentServiceStampsCount: 0,
		interiorType: 'Leather',
		invoiceDate: null,
		isTrade: false,
		isVatQualifying: null,
		isVehicleOnFinance: null,
		keeperStartDate: '2017-02-18T00:00:00.000Z',
		keysCount: 2,
		lastMOTDate: '2018-09-22T00:00:00.000Z',
		mileage: 49590,
		minimumBid: {
			type: 'offer',
			value: 10000,
		},
		missingPartsDesc: null,
		officialServiceStampsCount: 4,
		paintProblemsDesc: null,
		prepCosts: null,
		prettyVrm: 'FL64 WMV',
		previousKeepersCount: 2,
		priceAverageCondition: 0,
		priceGoodCondition: 0,
		priceRetail: 0,
		priceSource: 'CAP',
		priceUpdatedAt: null,
		saleTimeframe: '7 days',
		scratchesDesc: null,
		scuffedAlloyDesc: null,
		seller: {
			address1: null,
			address2: null,
			address3: null,
			area: null,
			city: null,
			email: 'dev+somecustomer@motorway.co.uk',
			latitude: null,
			longitude: null,
			mobile: '0800100100',
			name: 'Name',
			postcode: 'W1W5PA',
			town: null,
		},
		sellerWillAcceptPrice: 2245,
		serviceHistory: 'yes',
		soldDate: null,
		spec: {
			body: 'Estate',
			bodyCategory: 'Estate',
			colour: 'Grey',
			engineSize: 2993,
			firstRegistered: '2014-09-23T00:00:00.000Z',
			fuel: 'Diesel',
			make: 'Land Rover',
			model: 'Discovery HSE Luxury SDV6 A',
			transmission: 'Automatic',
			vin: 'SALLAAAG5FA735619',
		},
		state: {
			allowedNextStates: [
				{
					type: 'slug',
					value: 'sold',
				},
				{
					type: 'category',
					value: 'rejected',
				},
				{
					type: 'slug',
					value: 'ready_for_sale',
				},
				{
					type: 'slug',
					value: 'for_sale',
				},
				{
					type: 'slug',
					value: 'qa_ready',
				},
			],
			category: 'for_sale',
			id: 48,
			name: 'Under offer',
			slug: 'under_offer',
		},
		stateId: 48,
		trafficSource: null,
		truePrice: 29603,
		tyreProblemsDesc: null,
		updatedAt: '2020-06-07T09:10:14.465Z',
		v5LogBookOwnedBySeller: true,
		vehicleImages: [
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164005,
				kind: 'exterior_front_driver',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/exterior_front_driver-1550837234967.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164016,
				kind: 'exterior_rear_driver',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/exterior_rear_driver-1550838080022.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164017,
				kind: 'exterior_front_passenger',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/exterior_front_passenger-1550838056263.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164019,
				kind: 'exterior_rear_passenger',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/exterior_rear_passenger-1550838097246.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164022,
				kind: 'interior_front_seats',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/interior_front_seats-1550838137055.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164018,
				kind: 'interior_rear_seats',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/interior_rear_seats-1550838148485.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164021,
				kind: 'interior_dashboard',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/interior_dashboard-1550838159697.JPG',
			},
			{
				createdAt: null,
				enquiryId: 46947,
				id: 164020,
				kind: 'interior_boot',
				meta: null,
				source: null,
				url: 'https://motorway-stage.imgix.net/6947/46947/interior_boot-1550838170393.JPG',
			},
			{
				createdAt: '2020-11-24T11:25:31.483Z',
				damageMeta: null,
				enquiryId: 46947,
				id: 173077,
				kind: 'damage_windscreen',
				meta: {
					height: 720,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 960,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp--pr-418:48838f38c4f90edf8c970f30ef7a1f6b20eb5bc5',
				url: 'https://motorway-stage.imgix.net/1346/51346/51346-damage_windscreen-1606217130919.jpeg',
			},
		],
		vrm: 'FL64WMV',
		warningLightsDesc: null,
		windscreenProblemsDesc: null,
	});
};
